import React from "react";
import { cn } from "@synthesis/shared-utils";

import type { LineProps } from "../uploader.lib";

const Divider = () => <div className="h-full w-px bg-white" />;

export const Line = React.memo<LineProps>(({ uploadProgress }) => {
  return (
    <div className="bg-neutrals-90 relative flex h-4 w-full justify-evenly overflow-hidden rounded-full">
      <Divider />
      <Divider />
      <Divider />
      <Divider />
      <Divider />
      <Divider />
      <Divider />
      <Divider />
      <Divider />
      <Divider />
      <div
        className={cn(
          "bg-system-success-50 pointer-events-none absolute inset-y-0 left-0 h-full w-full rounded-full ease-linear",
          uploadProgress === 0 ? "-translate-x-full duration-0" : "duration-75",
        )}
        style={{ transform: `translateX(${-100 + uploadProgress}%)` }}
      />
    </div>
  );
});
